// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const mst: CountryValidator<"VN"> = createValidator(
  "vn.mst",
  174,
);

export default mst;
export const compact = mst.compact;
export const format = mst.format;
export const validate = mst.validate;
export const generate = (): string =>
  mst.generate?.() ??
  (() => {
    throw new Error(
      "Validator vn.mst cannot generate values",
    );
  })();
